export default __webpack_public_path__ + "static/media/red.60ccdc18.svg";